import { Serializable } from "./Serializable";

export class KeyDriverScoreDTO extends Serializable {
    
    keyDriverID: string;
    title: string;
    score: number;

    constructor() {
        super();
    }
    
}